import { useEffect } from 'react'

/**
 * Hook to configure page viewport scale and title
 * @param {Object} config - Configuration object
 * @param {string} config.title - Page title (optional)
 * @param {string} config.viewportScale - Initial viewport scale, defaults to '1' (optional)
 */
export const usePageConfig = ({ title, viewportScale = '1' } = {}) => {
  useEffect(() => {
    // Set page title
    if (title) {
      document.title = title
    }

    // Set viewport scale
    const viewportMeta = document.querySelector('meta[name="viewport"]')
    const originalContent = viewportMeta?.getAttribute('content')

    if (viewportMeta) {
      viewportMeta.setAttribute(
        'content',
        `width=device-width, initial-scale=${viewportScale}, shrink-to-fit=no`
      )
    }

    let link = document.querySelector("link[rel~='icon']")
    if (!link) {
      link = document.createElement('link')
      link.rel = 'icon'
      document.getElementsByTagName('head')[0].appendChild(link)
    }
    link.href = process.env.PUBLIC_URL + '/cl_favicon.png'

    // Cleanup: restore original viewport on unmount
    return () => {
      if (viewportMeta && originalContent) {
        viewportMeta.setAttribute('content', originalContent)
      }
    }
  }, [title, viewportScale])
}
